import { render, staticRenderFns } from "./StPatricksDay_drinkSection.vue?vue&type=template&id=50cc8e3b&scoped=true"
import script from "./StPatricksDay_drinkSection.vue?vue&type=script&lang=ts"
export * from "./StPatricksDay_drinkSection.vue?vue&type=script&lang=ts"
import style0 from "./StPatricksDay_drinkSection.vue?vue&type=style&index=0&id=50cc8e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cc8e3b",
  null
  
)

export default component.exports